import { Sha2562y5o7gt1rnojl as Sha256 } from './internal/Sha256.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { checkOffsetAndCount2b5icqlx5z1pu as checkOffsetAndCount } from './Util.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
  add2suhfggl4zvkk as add,
} from '../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { ByteString2qc03wzjsovk as ByteString } from './ByteString.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      sha256_x3qc5b_k$(sink) {
        return new (HashingSink())(sink, new (Sha256())());
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var HashingSinkClass;
function HashingSink() {
  if (HashingSinkClass === VOID) {
    class $ {
      constructor(sink, hashFunction) {
        this.sink_1 = sink;
        this.hashFunction_1 = hashFunction;
      }
      write_kzgu6x_k$(source, byteCount) {
        checkOffsetAndCount(source.size_1, 0n, byteCount);
        var hashedCount = 0n;
        var s = ensureNotNull(source.head_1);
        while (hashedCount < byteCount) {
          var tmp0 = subtract(byteCount, hashedCount);
          // Inline function 'okio.minOf' call
          var b = s.limit_1 - s.pos_1 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = fromInt(b);
          var tmp$ret$0 = tmp0 <= b_0 ? tmp0 : b_0;
          var toHash = convertToInt(tmp$ret$0);
          this.hashFunction_1.update_6igkux_k$(s.data_1, s.pos_1, toHash);
          // Inline function 'kotlin.Long.plus' call
          var this_0 = hashedCount;
          hashedCount = add(this_0, fromInt(toHash));
          s = ensureNotNull(s.next_1);
        }
        this.sink_1.write_kzgu6x_k$(source, byteCount);
      }
      flush_shahbo_k$() {
        return this.sink_1.flush_shahbo_k$();
      }
      close_yn9xrc_k$() {
        return this.sink_1.close_yn9xrc_k$();
      }
      get_hash_won4uv_k$() {
        var result = this.hashFunction_1.digest_m0ziv0_k$();
        return new (ByteString())(result);
      }
    }
    initMetadataForClass($, 'HashingSink');
    HashingSinkClass = $;
  }
  return HashingSinkClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instanceh4txywgfetw1,
};
//endregion

//# sourceMappingURL=HashingSink.mjs.map
